import "./Services.css";

const repairableShades = [
  "Honeycombs, Duettes, Applause, Pleated/Cellular",
  "Silhouettes",
  "Woodblinds",
  "Metals",
  "Vignettes",
  "Luminettes",
];

const Services = () => {
  return (
    <>
      <section className="section section--muted">
        <div className="section__inner about">
          <figure className="about__figure">
            <img src="/shade-services.png" alt="shade" />
          </figure>

          <div className="about__body">
            <h2 className="section-title">About</h2>
            <p className="about__text">
              AIM Blind and Drapery is a family-run business with over 21 years
              of experience serving the Bay Area Peninsula. As a proud division
              of Rebarts Interiors Hunter Douglas Gallery, we specialize in
              professional window blind repairs, dedicated to restoring beauty
              and functionality with fast turnaround times. Since 2009, we have
              been an authorized Hunter Douglas repair center, trusted by
              thousands of clients for our exceptional service and
              craftsmanship.
            </p>
          </div>
        </div>
      </section>

      <section className="section section--brand">
        <div className="section__inner">
          <h2 className="section-title services__title">Services</h2>

          <div className="services__grid">
            <div className="services-panel">
              <h3 className="services-panel__title">Repairable Shades</h3>

              <ul className="shade-list">
                {repairableShades.map((shade) => (
                  <li key={shade}>{shade}</li>
                ))}
                <li>
                  Roller shades{" "}
                  <span className="shade-list__note">(no design studio)</span>
                </li>
              </ul>
            </div>

            <div className="services-panel services-panel--notes">
              <p className="service-note service-note--strong">
                For Non-Hunter Douglas products please contact us.
              </p>
              <p className="service-note">
                We offer both drop-off and in-home services!
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
